import axios from 'axios';

const http = axios.create({
  baseURL: 'https://parallelum.com.br/fipe/api/v2/',
  headers: {
    'content-type': 'application/json',
  },
});

export async function getBrands({ type }) {
  const { data } = await http.get(`${type}/brands`);
  return data.map(({ name, code: value }) => ({ name, value }));
}

export async function getModels({ type, brand }) {
  const { data } = await http.get(`${type}/brands/${brand}/models`);
  return data.map(({ name, code: value }) => ({ name, value }));
}

export async function getYears({ type, brand, model }) {
  const { data } = await http.get(`${type}/brands/${brand}/models/${model}/years`);
  return data.map(({ name, code: value }) => ({ name, value }));
}

export async function getVehicle({
  type, brand, model, year,
}) {
  const { data } = await http.get(`${type}/brands/${brand}/models/${model}/years/${year}`);
  return {
    price: data.price,
    codeFipe: data.codeFipe,
    modelYear: data.modelYear,
    fuel: data.fuel,
  };
}
